import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.div`
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  cursor: pointer;
  transition: transform 0.2s;
  z-index: 2;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  width: 90px;
  height: 110px;
  margin: 66px 0 7px 266px;
  padding: 19px 7px 11.5px;
  box-shadow: 0 0 20px 0 ${Colours.shadowDark3};
  background-color: ${Colours.greenDark7};

  &:hover {
    transform: translateY(-50%) scale(1.1);
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      height: 40px;
      width: 40px;
    }

    p {
      color: ${Colours.white};
      font-size: 23px;
      font-weight: 500;
      margin-top: 0.5rem;
    }
  }
`;
